import PeopleImg from "public/openStack/difference/fluent_people-team-20-filled.svg";
import MaterialImg from "public/openStack/difference/material-symbols_contact-support-rounded.svg";
import IntegrationImg from "public/openStack/difference/oui_integration-general.svg";

export const DIFFERENCE_CONSTANTS = [
  {
    image: PeopleImg,
    title: "Tailored for CSPs, Enterprises, and DevOps Teams",
    text: "Run production workloads or offer your own IaaS services without the burden of infrastructure ops.",
  },
  {
    image: IntegrationImg,
    title: "OneMind PaaS Integration",
    text: "Seamlessly pair with OneMind’s Platform-as-a-Service to run applications, observability tools like Grafana, and Kubernetes clusters on top of your OpenStack.",
  },
  {
    image: MaterialImg,
    title: "Global Support, Local Expertise",
    text: "Our 24/7 NOC team and engineering experts offer hands-on support and proactive monitoring, no matter where you are in the world. ",
  },
];
